(function () {
  'use strict';

  // ===== Config =====
  var SF_TOKEN   = window.__SF_TOKEN || 'da11ae549267d55ed1e51eeab82f921e';
  var SF_VERSION = '2025-07';
  var ENDPOINT   = '/api/' + SF_VERSION + '/graphql.json';

  // Show this many Guru Picks
  var LIMIT = 4; 

  var container = document.getElementById('guru-picks');
  if (!container) return;

  var countEl = document.getElementById('guru-picks-count');

  // --- GraphQL Query ---
  // NOTE: filters ONLY supported on collection.products
  var QUERY =
    'query GuruPicks($first:Int!, $filters:[ProductFilter!]){' +
    '  collection(handle:"guru-picks"){' +
    '    products(first:$first, filters:$filters, sortKey:CREATED, reverse:true){' +
    '      pageInfo{ hasNextPage endCursor }' +
    '      nodes{' +
    '        id handle title' +
    '        priceRange{ minVariantPrice{ amount currencyCode } }' +
    '        compareAtPriceRange{ minVariantPrice{ amount currencyCode } }' +
    '        images(first:4){ nodes{ url altText } }' +
    '        collections(first: 10){ nodes{ handle } }' +   // ← NEW: membership for "sale" test
    '      }' +
    '    }' +
    '  }' +
    '}';


  // Build filter for exact value "YES"
  function buildFiltersArray() {
    var filters = [{
      productMetafield: {
        namespace: 'custom',
        key: 'online_guru_picks',
        value: 'YES'
      }
    }];
    console.log('[GuruPicks] Sending filters:', JSON.stringify(filters));
    return filters;
  }

  function money(amount, currency) {
    var n = Number(amount || 0);
    try { return new Intl.NumberFormat(undefined, { style:'currency', currency: currency || 'USD' }).format(n); }
    catch(e) { return n.toFixed(2) + ' ' + (currency || ''); }
  }

  function isProductInSaleCollection(p) {
    if (!p || !p.collections || !p.collections.nodes) return false;
    for (var i = 0; i < p.collections.nodes.length; i++) {
      var h = (p.collections.nodes[i] && p.collections.nodes[i].handle) || '';
      if (String(h).toLowerCase() === 'sale') return true;
    }
    return false;
  }


  function productCardHTML(p) {
    var imgs = (p.images && p.images.nodes) ? p.images.nodes : [];

    var mainSlides = imgs.map(function(img){
      return '' +
        '<a href="/products/' + p.handle + '" class="img-outer d-flex justify-content-center">' +
          '<img src="' + (img.url || '') + '" alt="' + (img.altText || p.title) + '">' +
        '</a>';
    }).join('');

    var thumbSlides = imgs.map(function(img){
      return '' +
        '<div class="nav-box"><div class="nav-box-inner">' +
          '<img src="' + (img.url || '') + '" alt="' + (img.altText || p.title) + '">' +
        '</div></div>';
    }).join('');

    var compare = p.compareAtPriceRange && p.compareAtPriceRange.minVariantPrice
      ? p.compareAtPriceRange.minVariantPrice : null;
    var price   = p.priceRange && p.priceRange.minVariantPrice
      ? p.priceRange.minVariantPrice : null;

    // NEW: sale detection is ONLY by collection membership
    var isSaleInCollection = isProductInSaleCollection(p);

    // Only show strikethrough/original when we actually have a compare drop
    var hasCompareDrop = !!(compare && price && Number(compare.amount) > Number(price.amount));

    // Price HTML – match collection page style (two prices only when sale+drop)
    var priceHTML = '';
    if (price) {
      if (isSaleInCollection && hasCompareDrop) {
        priceHTML =
          '<span class="txt--light-blue original price"><b>' + money(compare.amount, compare.currencyCode) + '</b></span>' +
          '<span class="txt--light-blue"><b>' + money(price.amount, price.currencyCode) + '</b></span>';
      } else {
        priceHTML =
          '<span class="txt--light-blue"><b>' + money(price.amount, price.currencyCode) + '</b></span>';
      }
    }

    // Sale label over the image (same markup as collection page)
    var saleLabelHTML = isSaleInCollection
      ? '<div class="sale-label"><span class="txt--dark-blue">Sale!</span></div>'
      : '';

    return '' +
      '<div class="box">' +
        '<div class="rectangle">' +
          '<div class="img-box">' +
            '<div class="slider-for">' + mainSlides + '</div>' +
            saleLabelHTML +
          '</div>' +
          '<div class="content-box">' +
            '<h4><a href="/products/' + p.handle + '" class="txt--dark-blue text-uppercase">' + p.title + '</a></h4>' +
            '<div class="price-wrapper d-flex align-items-center">' + priceHTML + '</div>' +
          '</div>' +
          '<div class="slider-nav-box"><div class="slider-nav">' + thumbSlides + '</div></div>' +
        '</div>' +
      '</div>';
  }


  // Use YOUR Slick settings exactly
  function initSlickFor(containerEl) {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
      console.warn('[GuruPicks] Slick not found. Load Slick JS/CSS.');
      return;
    }
    var $ = window.jQuery;

    $(containerEl).find('.box').each(function () {
      var $box = $(this);
      var $sliderFor = $box.find('.slider-for');
      var $sliderNav = $box.find('.slider-nav');

      $sliderFor.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: $sliderNav
      });

      $sliderNav.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: $sliderFor,
        dots: false,
        centerMode: false,
        focusOnSelect: true
      });
    });
  }

  function setCount(n) {
    if (!countEl) return;
    if (!n) countEl.textContent = 'No Guru Picks';
    //else countEl.textContent = 'Showing ' + n + ' Guru Pick' + (n === 1 ? '' : 's');
  }

  function fetchGuruPicks() {
    var variables = { first: LIMIT, filters: buildFiltersArray() };
    console.log('[GuruPicks] Request variables:', variables);

    return fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SF_TOKEN
      },
      body: JSON.stringify({ query: QUERY, variables: variables })
    })
      .then(function (res) {
        console.log('[GuruPicks] Response status:', res.status);
        if (!res.ok) throw new Error('Storefront API ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (json.errors) {
          console.error('[GuruPicks] GraphQL error:', json.errors);
          throw new Error('GraphQL errors');
        }
        if (!json.data || !json.data.collection) {
          console.warn('[GuruPicks] No "all" collection found. Create a collection or change handle in guru-picks.js.');
          return [];
        }
        var edge = json.data.collection.products;
        var nodes = edge ? edge.nodes : [];
        console.log('[GuruPicks] Products returned:', nodes.length);
        return nodes;
      });
  }

  // Run
  fetchGuruPicks()
    .then(function(products){
      if (!products.length) {
        setCount(0);
        return;
      }
      container.innerHTML = products.map(productCardHTML).join('');
      setCount(products.length);
      initSlickFor(container); // initialize Slick AFTER rendering
    })
    .catch(function(err){
      console.error('[GuruPicks] Failed:', err && err.message);
      container.innerHTML = '<p>Could not load Guru Picks right now.</p>';
      setCount(0);
    });

})();
